import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { CloseRoundedIcon, MoreVertRoundedIcon, LinkRoundedIcon } from '../../utils/constants'
import {Button, Loader} from '../'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAllPosts } from '../../actions/posts'
import './projects.css'

const Projects = () => {
  const dispatch                        = useDispatch();
  const [openButton, setOpenButton]     = useState({});
  const [loadMoreData, setLoadMoreData] = useState(false);
  const [loadLessData, setLoadLessData] = useState(false);
  const {isLoading, allPosts}           = useSelector((state) => state.postLists);
  const [projects, setProjects]         = useState(allPosts)
  const [visible, setVisible]           = useState(3)

  const imageButtonClick = (index) => {
    setOpenButton((prev) => ({ [index]: !prev[index] }));
    // setOpenButton((prev) => ({ ...prev, [index]: !prev[index] }));
  }
  
  useEffect(() => {
    setProjects(allPosts)
  }, [allPosts]);

  useEffect(() => {
    dispatch(fetchAllPosts);
  }, [dispatch]);

  const loadMoreBtn = () => {
    setLoadMoreData(true)

    setTimeout(() => {
      setVisible((prev) => prev + 3);
      setLoadMoreData(false);
    }, 1000);
  }
  const loadLessBtn = () => {
    setLoadLessData(true)

    setTimeout(() => {
    setVisible((prev) => prev - 3);
    setLoadLessData(false);
  }, 1000);
  }

  return (
    <>
      <section id='projects' className='projects-main-wrapper'>
        <h2>Projects</h2>
        <div className='projects-description'>My completed projects as a fullstack developer demonstrate my ability to create end-to-end solutions, ensuring robust functionality, compelling design, and seamless user experiences.</div>

        <div className='projects-box-container'>
        {isLoading ? <Loader /> : (
          projects.slice(0, visible).map((result, index) => (
            <div key={index} className='projects-box'>
              <div className='projects-box-image'>
                <img src={result.selectedFile} alt={result.title} />
                <span className='project-img-open-btn' onClick={() => imageButtonClick(index)}><MoreVertRoundedIcon /></span>
              </div>

              <div className={openButton[index] ? 'projects-box-link-container active' : 'projects-box-link-container'}>
                <span className='project-img-close-btn' onClick={() => imageButtonClick(index)}><CloseRoundedIcon /></span>
                <span>{result.title}</span>
                <Link to={result.link} className='project-link' target='_blank'><LinkRoundedIcon /> visit page</Link>
              </div>
            </div>
          ))
        )}
        </div>
        
        <div className='projects-box-btn'>
        {visible < projects.length && (
          <Button 
            onClickButton 
            onClickNavigate={loadMoreBtn} 
            buttonClickWrap={loadMoreData ? `button-login-submitted` : `button-login-submit`}
            onClickName={loadMoreData ? <>{<Loader />} Loading...</> : "See More"}
          />
        )}

        {visible > 3 && (
          <Button
            onClickButton
            onClickNavigate={loadLessBtn}
            buttonClickWrap={loadLessData ? `button-login-submitted` : `button-login-submit`}
            onClickName={loadLessData ? <>{<Loader />} Loading...</> : "See Less"}
          />
        )}
        </div>
      </section>
    </>
  )
}

export default Projects